var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "6345c11a9350ff572687c114_logo-linkedin-dark.svg",
    clipPath: "url(#clip0_1579_4079)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1579_4079",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_2381_670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 0.330078H0V16.3301H16V0.330078Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1579_4079)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.3 0.330078H0.7C0.3 0.330078 0 0.630078 0 1.03008V15.7301C0 16.0301 0.3 16.3301 0.7 16.3301H15.4C15.8 16.3301 16.1 16.0301 16.1 15.6301V1.03008C16 0.630078 15.7 0.330078 15.3 0.330078ZM4.7 13.9301H2.4V6.33008H4.8V13.9301H4.7ZM3.6 5.33008C2.8 5.33008 2.2 4.63008 2.2 3.93008C2.2 3.13008 2.8 2.53008 3.6 2.53008C4.4 2.53008 5 3.13008 5 3.93008C4.9 4.63008 4.3 5.33008 3.6 5.33008ZM13.6 13.9301H11.2V10.2301C11.2 9.33008 11.2 8.23008 10 8.23008C8.8 8.23008 8.6 9.23008 8.6 10.2301V14.0301H6.2V6.33008H8.5V7.33008C8.8 6.73008 9.6 6.13008 10.7 6.13008C13.1 6.13008 13.5 7.73008 13.5 9.73008V13.9301H13.6Z",
    fill: "#092540"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1579_4079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.330078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.5894dcc3c0953f24d9d23e1393998127.svg";
export { ForwardRef as ReactComponent };